import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import supabase from '../supabaseClient';

// ── OPERADOR: CONFIRMACIÓN DE LLEGADA ────────────────────────────
export const LlegadaConfirmadaScreen = ({ setCurrentUser }) => {
  const navigate = useNavigate();
  useEffect(() => {
    const t = setTimeout(async () => {
      await supabase.auth.signOut({ scope: "local" });
      navigate("/app");
      setCurrentUser(null);
    }, 2500);
    return () => clearTimeout(t);
  }, [navigate, setCurrentUser]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg,#0f5132 0%,#16a34a 50%,#22c55e 100%)", padding: "20px" }}>
      <div style={{ width: 112, height: 112, borderRadius: "50%", background: "rgba(255,255,255,0.15)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 24, boxShadow: "0 0 40px rgba(34,197,94,0.5)" }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="9" />
          <path d="M9 12l2 2l4 -4" />
        </svg>
      </div>
      <h1 style={{ fontSize: 26, fontWeight: 900, color: "white", margin: "0 0 8px 0", textAlign: "center" }}>Entrada registrada correctamente</h1>
      <p style={{ color: "#d1fae5", fontSize: 13, textAlign: "center" }}>Gracias, buen viaje.</p>
    </div>
  );
};
